import React from "react";

export default function Lucky7c({ data }) {
  const casinoResult = data?.casinoIndividualResultDTO;

  if (!casinoResult) {
    return <div>No data available</div>;
  }  

  // Helper function to generate card image URLs
  const getCardImage = (card) =>
    `https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/${card}.png`;

  return (
    <div className="modal-body">
      <div className="casino-result-modal">
        {/* Round ID and Match Time */}
        <div className="casino-result-round-id">
          <span>
            <b>Round Id: </b> {casinoResult.marketId}  
          </span>
          <span>
            <b>Match Time: </b>{" "}
            {new Date(casinoResult.createdAt + "Z").toLocaleString()}
          </span>
        </div>

        {/* Cards */}
        <div className="row mt-2">
          <div className="col-md-12 text-center">
            <div className="casino-result-cards">
              {casinoResult.casinoCardResultMaps[0]?.result.map(
                (card, index) => (
                  <img
                    key={index}
                    src={getCardImage(card)}
                    alt={`Card ${index}`}
                  />
                )
              )}
            </div>
          </div>
        </div>

        {/* Result Descriptions */}
        <div className="row mt-2 justify-content-center">
          <div className="col-md-6">
            <div className="casino-result-desc">
              {casinoResult.casinoIndividualResultMaps.map((result) => (
                <div key={result.id} className="casino-result-desc-item">
                  <div>{result.resultFor}</div>
                  <div>{result.result[0]}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}